export const FeatureFlags = {
  CLIENT_REFERENTIAL_ENABLED: 'nina-client-referential-enabled',
  REFONTE_DASHBOARD: 'nina-refonte-dashboard',
  EXCEL_GENERIQUE: 'nina-excel-generique',
};
